import { publicApi } from "@/lib/axios/instances";
import { SendOtpResponse } from "@/types/auth";

/**
 * Sends a login request to the admin authentication endpoint.
 * @param {Object} params - The login parameters.
 * @param {string} params.login - The admin login.
 * @param {string} params.password - The admin password.
 * @returns {Promise<{ access_token: string }>} A promise that resolves to an object containing the access token.
 */
export const adminLoginRequest = async (params: { login: string; password: string }): Promise<{ access_token: string }> => {
  const { data } = await publicApi.post<{ access_token: string }>('/admin-auth/login', {
    login: params.login,
    password: params.password,
  });
  return { access_token: data.access_token };
}

export const sendOtpRequest = async (contact: string): Promise<SendOtpResponse> => {
  const { data } = await publicApi.post<SendOtpResponse>('/auth/send-otp', { contact });
  return data;
}

export const verifyOtpRequest = async (contact: string, otp: string): Promise<{ access_token: string }> => {
  const { data } = await publicApi.post<{ id: string, access_token: string }>('/auth/verify-otp', { contact, otpCode: otp });
  return { access_token: data.access_token };
}

export const logoutRequest = async (): Promise<void> => {
  await publicApi.post('/auth/logout');
}